module.exports = __webpack_public_path__ + "files/e0ed9f971180af88bd5ff018ca31d8b9.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/people-4.png
// module id = 1368
// module chunks = 59